import {VolumeIcon} from "../Icons";
import React from "react";

export default ({muted, volume, onChange}) => (
    <a onClick={onChange}>
        <VolumeIcon
            muted={muted}
            level={volume}
        />
    </a>
)
